import * as Yup from "yup";
import { produtoValidator } from "../../produtos/addProduto/middlewares";

const produtosCsvValidator = Yup.array()
  .of(produtoValidator)
  .min(1, "Adicione ao menos um item")
  .required("Adicione ao menos um item");

export default produtosCsvValidator;
